import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  -webkit-margin-bottom-collapse: separate;\n  padding: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  margin: 0;\n  min-width: 0;\n  padding: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: normal;\n  margin: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  cursor: pointer;\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: inherit;\n  margin-right: auto;\n  padding: 0;\n  text-align: left;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { typography } from '@scp/ui-shared/theme/variables';
export var ClearedButton = styled.button(_templateObject(), typography.fontFamily, typography.defaultFontSize, typography.defaultFontWeight);
export var ClearedInput = styled(ClearedButton.withComponent('input'))(_templateObject2());
export var VisuallyHiddenStyle = css(_templateObject3());
export var VisuallyHiddenElement = styled.span(_templateObject4(), VisuallyHiddenStyle);
export var ClearedUl = styled.ul(_templateObject5());
export var ClearedFieldset = styled.fieldset(_templateObject6());
export var ClearedDl = styled.dl(_templateObject7());
export var ClearedLegend = styled.legend(_templateObject8());